import { QueryClientProvider } from '@tanstack/react-query';
import { useCallback, type ReactNode } from 'react';
import { Toaster } from 'sonner';
import { ConfirmProvider } from '@/components/ui/confirm';
import { TooltipProvider } from '@/components/ui/tooltip';
import { AuthProvider } from '@/lib/auth';
import { HotkeysProvider } from '@/lib/hotkeys';
import { queryClient } from '@/lib/query-client';
import { ThemeProvider, useTheme } from '@/lib/theme';

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster theme={theme} position="bottom-right" richColors closeButton duration={4000} />;
}

export function Providers({ children }: { children: ReactNode }) {
  const clearCache = useCallback(() => queryClient.clear(), []);
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider onLogout={clearCache}>
          <TooltipProvider delayDuration={300}>
            <ConfirmProvider>
              <HotkeysProvider>{children}</HotkeysProvider>
            </ConfirmProvider>
          </TooltipProvider>
        </AuthProvider>
      </QueryClientProvider>
      <ThemedToaster />
    </ThemeProvider>
  );
}
